import { createSlice } from "@reduxjs/toolkit";



export const checkCGVSlice = createSlice({ //reducers for 2 dates in global state
    name: 'checkCGV',
    initialState:{},
    reducers: {
        setCGV: (currentState, action) => {
            
            if (action.payload.index===1){ //which date do we have to update? start or return?
                return [action.payload.check,currentState[1]] //update start date, keep return date
            }
            else{
                return [currentState[0],action.payload.check]; //update return date, keep start date
            }

        },
        resetCGV: (currentState, action) => {
            
            return [false,false]; 

        }
    }

});


